import React from 'react'
import { observer } from 'mobx-react'
import ACL from '@components/ACL'

import { NavLink, withRouter } from 'react-router-dom'

const MobileTabs = ({ defaultTab, tabs, match, ignoreExactMatches }) => {
  React.useEffect(() => {
    document
      .querySelector('html')
      .setAttribute('style', 'min-width: 0!important')
    document
      .querySelector('body')
      .setAttribute('style', 'min-width: 0!important')
    document
      .querySelector('.project-wrapper')
      .setAttribute(
        'style',
        'min-width: 0; padding: 0; padding-top: 10px; height: calc(100vh - 100px)'
      )
    document
      .querySelector('.views-wrapper')
      .setAttribute('style', 'height: calc(100vh - 210px)')
    document
      .querySelector('.expert-search-results')
      .setAttribute('style', 'min-height: 0')
    document
      .querySelector('.scroll-container')
      .setAttribute('style', 'height: calc(100vh - 100px); margin-top: 10px')
    document
      .querySelector('.scroll-inner')
      .setAttribute('style', 'overflow: hidden')

    return () => {
      document
        .querySelector('html')
        .setAttribute('style', 'min-width: 1920!important')
      document
        .querySelector('body')
        .setAttribute('style', 'min-width: 1920!important')
      document.querySelector('.project-wrapper').setAttribute('style', '')
      document.querySelector('.views-wrapper').setAttribute('style', '')
      document.querySelector('.expert-search-results').setAttribute('style', '')
      document.querySelector('.scroll-container').setAttribute('style', '')
    }
  })

  const renderTab = ({ tabName, label, link, roles, highlight }) => {
    const tabEl = (
      <NavLink
        exact={!ignoreExactMatches.includes(tabName)}
        to={link}
        key={tabName}
        activeClassName="tab--active"
        className="tab tab__link"
        style={{ listStyleType: 'none' }}>
        <li
          title={highlight ? 'Search keywords present on this page' : ''}
          style={{ textTransform: 'capitalize' }}
          className="mobile-tab-link">
          {highlight ? <span className="tab__bullet">&bull; </span> : ''}
          {label}
        </li>
      </NavLink>
    )

    if (roles && roles.length) {
      return (
        <ACL inline key={tabName} roles={roles}>
          {tabEl}
        </ACL>
      )
    }

    return tabEl
  }

  const renderTabs = () => {
    return tabs.map(tab => {
      let roles
      let tabName
      let tabUrl

      if (typeof tab === 'string') {
        tabName = tab
        tabUrl = tab
      } else {
        roles = tab.roles
        tabName = tab.tabName || tab.tab
        tabUrl = tab.tab
      }

      let tabSlug = ''
      if (tabUrl !== defaultTab) tabSlug = '/' + tabUrl

      const link = match.url + tabSlug
      const label = tabName.replace(/-/g, ' ')

      return renderTab({
        tabName,
        label,
        link,
        roles,
        highlight: tab.highlight
      })
    })
  }

  return (
    <div className="mobile-tabs__container">
      <nav className="mobile-tabs__scrollable-container">
        <div
          className="mobile-tabs"
          style={{ overflow: 'auto', whiteSpace: 'nowrap' }}>
          {renderTabs()}
        </div>
      </nav>
    </div>
  )
}

export default observer(withRouter(MobileTabs))
